import { formatBalanceAccounts } from '»utils/accounts';

export const getAccountBalance = (state) =>
  formatBalanceAccounts(state.accountBalance.data);

export const accountBalanceSelectedSelector = (state) =>
  state.accountBalance.selectedAccount;
